import dayjs from 'dayjs';

/**
 * Normaliza um nome removendo uma substring específica, se presente, e mantendo apenas o primeiro e o último nome.
 * 
 * @param {string} name - O nome a ser normalizado, que pode conter a substring 'Supervisor - '.
 * @returns {string} O nome normalizado, contendo apenas o primeiro e o último nome, com cada parte iniciando com letra maiúscula.
 * 
 * @example
 * // retorna 'Rodrigo Oliveira'
 * normalizeName('Rodrigo Oliveira');
 * 
 * @example
 * // retorna 'Leandra Oliveira'
 * normalizeName('Leandra Alves Souza De Oliveira');
 * 
 * @example
 * // retorna 'Ana Miguel'
 * normalizeName('Ana Flavia Gomes Miguel');
 */
function normalizeName(name) {
  const nameParts = name.replace('Supervisor - ', '').trim().split(' ');

  const cleanName = nameParts.length > 1 ? `${nameParts[0]} ${nameParts[nameParts.length - 1]}` : nameParts[0];

  return cleanName
    .split(' ')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Calcula as datas de início e fim para um dado mês, baseando-se na data atual, 
 * considerando o fuso horário de São Paulo (America/Sao_Paulo).
 * A data de início é definida como o primeiro dia do mês às 00:00:00 horas,
 * enquanto a data de término é o dia atual do mês às 23:59:59 horas.
 *
 * @param {string} currentDate - A data atual no formato de string (YYYY-MM-DD).
 * @returns {Object} Um objeto contendo as strings de data de início (startDate) 
 * e de término (endDate) para o mês da data fornecida.
 */
function getStartEndDate(currentDate) {
  const date = dayjs(currentDate + 'T00:00:00').tz('America/Sao_Paulo');
  const year = date.year();
  const month = date.month() + 1;
  const day = date.date();

  const startDate = `${year}-${month.toString().padStart(2, '0')}-01 00:00:00`;
  const endDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} 23:59:59`;

  return {
    startDate,
    endDate,
  };
}


/**
 * Obtém o intervalo de datas para o mês da data fornecida, considerando o fuso horário de São Paulo.
 * A data de início é o primeiro dia do mês às 00:00:00 horas,
 * e a data de término é o dia atual do mês fornecido às 23:59:59 horas.
 * 
 * @param {string} currentDate - A data atual no formato de string (YYYY-MM-DD).
 * @returns {Object} Um objeto contendo a data de início (startDate) e a data de término (endDate) do mês.
 */
function getDateRange(currentDate) {
  const date = dayjs(currentDate).tz('America/Sao_Paulo');
  const year = date.year();
  const month = date.month() + 1;
  const day = date.date();
  const startDate = `${year}-${month
    .toString()
    .padStart(2, '0')}-01T00:00:00`;
  const endDate = `${year}-${month.toString().padStart(2, '0')}-${day
    .toString()
    .padStart(2, '0')}T23:59:59`;
  return { startDate, endDate };
}

const CRITERIA_OPTIONS = [
  {
    id: 1,
    label: 'Placa',
    type: 'TotalVendas',
    imageUrl: 'https://bboneapp.s3.amazonaws.com/uploads/SUPERRANKING-GUSTTAVO-LUAN-WESLEY.png',
    altText: 'Imagem de mala de viagem',
  },
  {
    id: 2,
    label: 'Arrecadação',
    type: 'ValorPrimeiraParcela',
    imageUrl: 'https://bboneapp.s3.amazonaws.com/uploads/SUPERRANKING-CARRO-0KM.png',
    altText: 'Imagem de carro',
  },
];

export { normalizeName, getStartEndDate, getDateRange, CRITERIA_OPTIONS };
